
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { Tools } from "babylonjs";

import * as Questions from "@/data/questions";
import * as Events from "@/data/events";
import * as Audio from "@/game-engine/audio";
import * as Camera from "@/game-engine/camera";
import { trimImage } from "@/game-engine/helpers";
import {
  animating,
  animationStatus,
  AnimationStatus,
} from "@/game-engine/animation";
import * as Config from "@/game-engine/config";

import { useCanvas, disposeCanvas } from "@/game-engine";
import { processAnswer } from "@/game-engine/environment";
import store from "@/game-engine/store";

import { useTypedStore } from "@/store";
import router from "@/router";

Events.awake();
Questions.awake();

export default defineComponent({
  name: "Game",

  setup() {
    const canvasRef = ref<HTMLCanvasElement | null>(null);
    const { state, getters, commit, dispatch } = useTypedStore();

    const activeEvents = ref<Events.Event[]>([]);
    const cityComplete = ref<boolean>(false);

    const toggled = ref<boolean[]>([false, false, false, false, false]);

    let previousQuestionId = -1;
    let previousQuestion: Questions.Question;
    let previousAnswer: Questions.Answer;

    const dismissEvent = () => {
      if (activeEvents.value.length > 0) {
        const activeEvent = activeEvents.value[0];
        activeEvent.activated = true;

        commit("handleEvent", activeEvent);

        activeEvents.value.shift();

        if (activeEvents.value.length === 0) {
          Camera.reset();
        } else {
          Audio.playSFX(Audio.SoundEffects.Popup);
        }
      }
    };

    function select(index: number) {
      toggled.value = [false, false, false, false, false];
      toggled.value[index] = true;
    }

    const incrementAnswer = async (key: string, questionId: string) => {
      const success: boolean = await dispatch("incrementAnswer", {
        key: key,
        questionId: questionId,
      });
    };

    const submitAnswer = (answer: Questions.Answer) => {
      previousQuestionId = state.questionId;
      previousQuestion = getters.currentQuestion;
      previousAnswer = answer;

      toggled.value = [false, false, false, false, false];

      commit("submitAnswer", answer);
      commit("addAnswer", answer);

      incrementAnswer(answer.key, state.questionId.toString());

      Audio.playSFX(Audio.SoundEffects.UIButton);

      activeEvents.value = Events.getActiveEvents();

      setTimeout(() => {
        commit("nextQuestion", undefined);

        if (activeEvents.value.length > 0) {
          Audio.playSFX(Audio.SoundEffects.Popup);
        }
      }, Config.CAMERA_ANIMATION_LENGTH * 40);

      processAnswer(
        previousAnswer.modelPath,
        previousQuestion.buildModelPath,
        previousQuestionId,
        activeEvents.value.length === 0,
        true
      );
    };

    const tick = () => {
      if (!getters.currentQuestion && !animating.value) {
        cityComplete.value = true;
      } else {
        setTimeout(() => {
          tick();
        }, 100);
      }
    };

    const goToResults = () => {
      Tools.CreateScreenshot(
        store.engine,
        store.screenshotCamera,
        {
          // width: 1280,
          // height: 720,
          // precision: 2
        },
        function(data) {
          trimImage(data).then((img) => {
            commit("saveScreenshot", (img as any).data);
          });

          // commit("saveScreenshot", data);

          disposeCanvas();

          router.push("./results");
        }
      );
    };

    onMounted(() => {
      previousQuestionId = -1;

      disposeCanvas();
      commit("resetState", undefined);

      if (canvasRef.value) {
        useCanvas(canvasRef.value);
      }

      tick();

      if (!state.isDev) {
        dispatch("addPlay");
      }
    });

    return {
      state,
      getters,
      canvasRef,
      submitAnswer,
      activeEvents,
      dismissEvent,
      animating,
      animationStatus,
      AnimationStatus,
      cityComplete,
      goToResults,
      toggled,
      select,
    };
  },
});
